// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wt","ribbon":"wu","title":"wv","genres":"ww"};